import * as React from 'react';

import { Box, Button, CircularProgress, Typography } from '@mui/material';

import styles from './SubmitFooter.module.css';

export interface SubmitFooterProps {
  onSubmit: () => void;
  onCancel?: () => void;
  submitting?: boolean;
  /** The Submit button only appears once the form can actually be submitted. */
  showSubmit?: boolean;
  submitLabel?: string;
  /** Explains what is still missing, e.g. links to incomplete sections. */
  status?: React.ReactNode;
}

/** Sticky action bar for a single-page form: Cancel on the left, Submit on the right. */
const SubmitFooter: React.FC<SubmitFooterProps> = ({
  onSubmit,
  onCancel,
  submitting,
  showSubmit = true,
  submitLabel = 'Submit request',
  status,
}) => (
  <Box className={styles.footer} component="footer">
    <Box className={styles.left}>
      {onCancel && (
        <Button color="inherit" onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
      )}
    </Box>
    <Box className={styles.right}>
      {status && (
        <Typography variant="body2" color="text.secondary" component="div" aria-live="polite">
          {status}
        </Typography>
      )}
      {showSubmit && (
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={submitting}
          startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {submitting ? 'Submitting…' : submitLabel}
        </Button>
      )}
    </Box>
  </Box>
);

export default SubmitFooter;
